import React from 'react';
import { useLocation } from 'react-router-dom';
import { ReceiptIcon } from '@shopify/polaris-icons';
import { Navigation } from '@shopify/polaris';

const VendorSidebar: React.FC = () => {
  const location = useLocation();

  const navigationItems = [
    {
      label: 'Vendor Management',
      url: '/vendors/invoices',
      icon: ReceiptIcon as any,
      matches: true,
      subNavigationItems: [
        {
          url: '/vendors/invoices',
          disabled: false,
          label: 'Invoice List',
        },
        {
          url: '/vendors/invoices/upload',
          disabled: false,
          label: 'Upload Invoice',
        },
        {
          url: '/vendors/sync/servman-vendors',
          disabled: false,
          label: 'ServMan Vendors',
        },
        {
          url: '/vendors/sync/vendor-contacts',
          disabled: false,
          label: 'Vendor Contacts',
        },
        {
          url: '/vendors/sync/servman-invoices',
          disabled: false,
          label: 'ServMan Invoices',
        },
        {
          url: '/vendors/sync/docuware-invoices',
          disabled: false,
          label: 'DocuWare Invoices',
        },
      ],
    },
  ];

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={navigationItems} />
    </Navigation>
  );
};

export default VendorSidebar;
